import { encodeParams } from '../../../helpers'

function requestAPI(token, queryString) {
  return fetch(`${process.env.REACT_APP_AGENT_URL}transaction?${queryString}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token
    }
  }).then((res) => res.json())
}

export default function actionListTransaction(
  pageParam = 1,
  limitParam = 10,
  searchParam = null,
  startDateParam = null,
  endDateParam = null,
  statusParam = null
) {
  return async (dispatch, getState) => {
    try {
      dispatch({
        type: 'LIST_TRANSACTION_BEGIN'
      })

      let page = pageParam
      let limit = limitParam
      let search = searchParam || (typeof pageParam === 'object' ? pageParam.code : null)
      let start_date = startDateParam
      let end_date = endDateParam
      let status = statusParam

      if (typeof pageParam === 'object' && pageParam !== null) {
        page = pageParam.page || 1
        limit = pageParam.limit || 10
        search = pageParam.search !== undefined ? pageParam.search : (pageParam.code || null)
        start_date = pageParam.start_date || null
        end_date = pageParam.end_date || null
        status = pageParam.status !== undefined ? pageParam.status : null
      }

      const params = {
        page: page || 1,
        limit: limit || 10
      }
      if (search) params.search = search
      if (start_date) params.start_date = start_date
      if (end_date) params.end_date = end_date
      if (status !== null && status !== undefined && status !== '') params.status = status

      const queryString = await encodeParams(params)

      const token = (getState().auth && getState().auth.authenticate)
        ? getState().auth.authenticate.token
        : localStorage.getItem('nabawi-token')

      const result = await requestAPI(token, queryString)

      if (!result.status) {
        handleErrors(dispatch, result)
        return
      }

      dispatch({
        type: 'LIST_TRANSACTION_SUCCESS',
        payload: result.data
      })
    } catch (err) {
      handleErrors(dispatch, err)
    }
  }
}

function handleErrors(dispatch, error) {
  dispatch({
    type: 'LIST_TRANSACTION_FAILURE',
    error: error
  })
}
